export const SOUSA_MURRAY_IDENTITY = Object.freeze({
  provider: 'Sousa Murray ID',
  administration: 'https://identity.sousamurray.co.uk',
  issuer: 'https://id.sousamurray.co.uk',
  accountCentre: 'https://my.sousamurray.co.uk',
  implementationRepository: 'alfiemurray03/sousamurray-id',
});

export const identityHost = value => {
  try { return new URL(value).host; }
  catch { return String(value || ''); }
};
